import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import NewsRequests from "services/news";
import GridContainer from "@jumbo/components/GridContainer";
import { Box, Grid } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { animateScroll as scroll } from "react-scroll";
import Notificatoin from "./Notification";

const AllNotifications = () => {
  const {
    notifications,
    notificationsCurrentPage,
    notificationsTotalPage,
  } = useSelector(({ news }) => news);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(NewsRequests.getAllNotifications(1));
  }, []);
  const handleChangePagination = (_, value) => {
    dispatch(NewsRequests.getAllNotifications(value));
    scroll.scrollToTop();
  };

  return (
    <>
      <GridContainer>
        <Grid item xs={12}>
          <Notificatoin />
          {notifications &&
            notifications.map((notification) => (
              <Notificatoin key={notification._id} notification={notification} />
            ))}
        </Grid>
      </GridContainer>
      <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
        <Pagination
          count={notificationsTotalPage}
          color="primary"
          page={notificationsCurrentPage}
          onChange={handleChangePagination}
        />
      </Box>
    </>
  );
};

export default AllNotifications;
